import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

export default {
  id: 'MicrosoftBuildings',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/bing/wms?SERVICE=WMS',
  title: {
    'en-US': 'Microsoft Buildings',
    'pt-BR': 'Edifícios da Microsoft',
    'es-ES': 'Edificios de Microsoft',
    'fr-FR': 'Bâtiments Microsoft'
  },
  zindex: 1, // TODO: CHECK
  active: false,
  activeTarget: 'visibility',
  customProperties: { group: 'reference' },
  legend: {
    title: 'n/a' // TODO: CHECK
  },
  minZoomLevel: 16,
  sublayers: [
    {
      id: 'usbuildings',
      visible: true,
      layers: 'usbuildings',
      legend: {
        title: {
          'en-US': 'Microsoft Buildings',
          'pt-BR': 'Edifícios da Microsoft',
          'es-ES': 'Edificios de Microsoft',
          'fr-FR': 'Bâtiments Microsoft'
        },
        items: [
          {
            text: {
              'en-US': 'Microsoft Buildings',
              'pt-BR': 'Edifícios da Microsoft',
              'es-ES': 'Edificios de Microsoft',
              'fr-FR': 'Bâtiments Microsoft'
            },
            color: '#FF151577',
            icon: 'mdi-vector-polygon'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
} as LayerRaw
